// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"054aaa5a","543":"387f8a11","709":"24117271","796":"275a2468"}[chunkId] + ".chunk.js";
};